
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import EmployeeService from "../../services/resource/employeeService";
import LOGO from '../../assets/york.png'
import InputForm from "../../components/input/input";
import './styles.css'
import { toast } from 'react-toastify';
import ButtonLoading from "../../components/buttonLoading/buttonLoading";

function EsqueceuSenha() {
    const service = new EmployeeService();
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const sendResetPassword = (event) => {
        event.preventDefault();

        service.sendResetPassword(email).then(() => {
            navigate('/login');
            toast.success("Foi enviado um e-mail com instruções para alteração de senha")
        }).catch((error) => {
            setError(error.response.data.message)
        })
    };

    useEffect(() => {
        setError('')
    }, [email])

    return (
        <div style={{height:'100vh'}} className="flex items-center justify-center  px-4">
            <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
                <div className="flex justify-center mb-6">
                    <img src={LOGO} alt="LOGO YORK" className="h-12 w-auto" />
                </div>

                <form onSubmit={sendResetPassword} className="space-y-4">
                    <div>
                        <InputForm
                            id="email"
                            type="text"
                            label="Informe o e-mail cadastrado"
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>

                    {error && <p className="text-sm text-red-600 mt-1">{error}</p>}

                    <div className="flex justify-center space-x-2 pt-2 mt-4">
                        <ButtonLoading type="button" label="Voltar" color="gray" onClick={() => navigate('/login')} />
                        <ButtonLoading type="submit" label="Recuperar Senha" color="indigo" />

                    </div>
                </form>
            </div>
        </div>
    );
}

export default EsqueceuSenha;